/* Manu AI v26 (23/10/2026) — écran de placement mobile plus généreux + Manu reprend la main quand il pose une question ou bloque.
 * - Mobile : l'historique des designs (onglets) est replié : un bouton dans l'en-tête (avec le nombre de designs) l'ouvre ; plus de bande permanente.
 * - Mockup : boutons d'action en superposition sur le mockup, qui prend toute la largeur et la hauteur disponible (CSS v26 + cadre portrait v24).
 * - Si Manu pose une question (pastilles de réponse) ou bloque (plus de création offerte), l'écran bascule sur le chat et y reste.
 * S'appuie sur section._ais enrichie par v9 → v25 (setView / getView : v18). */
(function () {
  'use strict';

  var TXT = {
    fr: { designs: 'Mes designs', chat: 'Revoir la conversation', back: 'Revenir au mockup' },
    en: { designs: 'My designs', chat: 'Back to the chat', back: 'Back to the mockup' },
    es: { designs: 'Mis diseños', chat: 'Volver al chat', back: 'Volver al mockup' },
    de: { designs: 'Meine Entwürfe', chat: 'Zurück zum Chat', back: 'Zurück zum Mockup' },
    it: { designs: 'I miei design', chat: 'Torna alla chat', back: 'Torna al mockup' }
  };
  var ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="3" width="13" height="13" rx="2"/><path d="M16 20H5a2 2 0 0 1-2-2V8"/></svg>';

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v26 || !inst._v18 || !inst._v24 || !inst._v25) return;
    inst._v26 = true;
    var dlg = inst.dialog; if (!dlg) return;
    dlg.setAttribute('data-v26', '');
    function tx() { return TXT[inst.loc] || TXT.fr; }

    /* ---------- Historique des designs : un bouton dans l'en-tête, la liste s'ouvre à la demande (mobile) ---------- */
    var bar = dlg.querySelector('.ais-dtabs'), head = dlg.querySelector('.ais-dialog__head'), restart = dlg.querySelector('[data-ais-restart]');
    if (bar && head && restart) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'ais-icon-btn ais-icon-btn--round ais26-dt'; btn.hidden = true; btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = ICON + '<b class="ais26-dt__n" aria-hidden="true"></b>';
      head.insertBefore(btn, restart);
      var sync = function () {
        var n = bar.querySelectorAll('.ais-dtab').length, label = tx().designs + (n ? ' (' + n + ')' : '');
        btn.hidden = bar.hidden || !n;
        btn.setAttribute('aria-label', label); btn.title = label;
        btn.querySelector('.ais26-dt__n').textContent = n || '';
        if (btn.hidden) { dlg.removeAttribute('data-v26-dt'); btn.setAttribute('aria-expanded', 'false'); }
      };
      new MutationObserver(sync).observe(bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      btn.addEventListener('click', function () {
        var on = dlg.getAttribute('data-v26-dt') !== 'open';
        if (on) dlg.setAttribute('data-v26-dt', 'open'); else dlg.removeAttribute('data-v26-dt');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      // Choisir un design referme la liste
      bar.addEventListener('click', function (e) { if (e.target.closest('[data-dtab]')) { dlg.removeAttribute('data-v26-dt'); btn.setAttribute('aria-expanded', 'false'); } });
      dlg.addEventListener('ais:locale', sync);
      sync();
    }

    /* ---------- Mobile : en-tête sur une seule ligne (Manu AI + 3 étapes en pastilles + boutons) ---------- */
    var stepsEl = dlg.querySelector('[data-ais-steps]'), headEl = dlg.querySelector('.ais-dialog__head'), MQM = window.matchMedia('(max-width: 749px)');
    function placeSteps() {
      if (!stepsEl || !headEl) return;
      if (MQM.matches) headEl.insertBefore(stepsEl, headEl.querySelector('.ais26-dt') || headEl.querySelector('[data-ais-restart]'));
      else if (stepsEl.parentNode === headEl) headEl.parentNode.insertBefore(stepsEl, headEl.nextSibling);
    }
    if (MQM.addEventListener) MQM.addEventListener('change', placeSteps); else if (MQM.addListener) MQM.addListener(placeSteps);
    placeSteps();

    /* ---------- Un seul bouton de va-et-vient, toujours au même endroit (sous les étapes) : « Revoir la conversation » ⇄ « Revenir au mockup » ---------- */
    var ret = dlg.querySelector('.ais24-ret'), retBtn = ret && ret.querySelector('button');
    function labelRet() {
      if (!retBtn) return;
      var onStage = dlg.getAttribute('data-view') === 'stage', T = tx();
      retBtn.setAttribute('data-v24', onStage ? 'chat' : 'stage');
      retBtn.querySelector('span').textContent = onStage ? T.chat : T.back;
      var svg = retBtn.querySelector('svg'); if (svg) svg.style.transform = onStage ? 'none' : 'rotate(180deg)';
      if (svg) svg.innerHTML = onStage ? '<path d="M4 5h16v11H9l-5 4z"/>' : '<path d="M5 12h14M13 6l6 6-6 6"/>';
    }
    if (retBtn) {
      new MutationObserver(labelRet).observe(dlg, { attributes: true, attributeFilter: ['data-view'] });
      dlg.addEventListener('ais:locale', function () { setTimeout(labelRet, 0); });
      labelRet();
    }

    /* ---------- Importer un fichier depuis le mockup : on reste sur le mockup (le chargeur du chat ramenait à la conversation) ---------- */
    var baseOwn = inst.ownFile, quiet = false;
    inst.ownFile = function (file, side, fromHero) {
      if (!fromHero && this.dialog.open && this.resultEl && this.getView && this.getView() === 'stage') { quiet = true; this._quietUser = true; }
      try { return baseOwn.apply(this, arguments); } finally { quiet = false; this._quietUser = false; }
    };
    var baseLoad = inst.startLoader;
    inst.startLoader = function () { if (quiet) return { el: null, steps: 1, step: 0 }; return baseLoad.apply(this, arguments); };

    /* ---------- Manu pose une question ou bloque : on bascule sur le chat et on y reste ---------- */
    var blocked = false, bt = 0;
    var baseChips = inst.chips;
    inst.chips = function (opts) {
      if (opts && opts.length && inst.getView && inst.getView() === 'stage') inst.setView('chat');
      return baseChips.apply(this, arguments);
    };
    var baseGen = inst.generateFaces;
    inst.generateFaces = function () {
      if (this.left && this.left() <= 0) { blocked = true; clearTimeout(bt); bt = setTimeout(function () { blocked = false; }, 3500); }   // plus de création offerte : le message de Manu reste à l'écran
      return baseGen.apply(this, arguments);
    };
    var baseShow = inst.showResult;
    inst.showResult = function () {
      if (blocked) { blocked = false; return; }
      return baseShow.apply(this, arguments);
    };
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      var i = root._ais;
      if (i && i._v18 && i._v24 && i._v25) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
